import styled from "styled-components";

export const StyledLoadingThumbnail = styled.div<{ $marginTop?: number }>`
  width: 100%;
  height: calc(100vh - ${({ $marginTop }) => $marginTop ?? 0}px);
`;
